<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Chapter-Title-Page-Break--Body-" id="_idParaDest-2"><span class="CharOverride-1">Contents</span></p>
<p class="ORIM-Body-Text-No-Indent--Body- ParaOverride-2"><span class="CharOverride-1"><a href="#/FranklinAve3">Tourette’s of the Heart</a></span></p>
<p class="ORIM-Body-Text-No-Indent--Body- ParaOverride-2"><span class="CharOverride-1"><a href="#/FranklinAve4">Swisher Sweets</a></span></p>
<p class="ORIM-Body-Text-No-Indent--Body- ParaOverride-2"><span class="CharOverride-1"><a href="#/FranklinAve5">Sweet Nothings</a></span></p>
<p class="ORIM-Body-Text-No-Indent--Body- ParaOverride-2"><span class="CharOverride-1"><a href="#/FranklinAve6">The House of Naan and Saffron</a></span></p>
<p class="ORIM-Body-Text-No-Indent--Body- ParaOverride-2"><span class="CharOverride-1"><a href="#/FranklinAve7">The Franklin Avenue Rookery for Wayward Babies</a></span></p>
<p class="ORIM-Body-Text-No-Indent--Body- ParaOverride-2"><span class="CharOverride-1"><a href="#/FranklinAve8">The Little Ice Girl</a></span></p>
<p class="ORIM-Body-Text-No-Indent--Body- ParaOverride-2"><span class="CharOverride-1"><a href="#/FranklinAve9">Good as Biscotti</a></span></p>
<p class="ORIM-Body-Text-No-Indent--Body- ParaOverride-2"><span class="CharOverride-1"><a href="#/FranklinAve10">Pink Flamingos and the Good Friday Massacres</a></span></p>
<p class="ORIM-Body-Text-No-Indent--Body- ParaOverride-2"><span class="CharOverride-1"><a href="#/FranklinAve11">Silver</a></span></p>
<p class="ORIM-Body-Text-No-Indent--Body- ParaOverride-2"><span class="CharOverride-1"><a href="#/FranklinAve12">The Color of Fisticuffs and Bloodlines</a></span></p>
<p class="ORIM-Body-Text-No-Indent-SpB4--Body- ParaOverride-2"><span class="CharOverride-2"><a href="#/FranklinAve13">About the Author</a></span></p>
<p class="ORIM-Body-Text-No-Indent--Body- ParaOverride-2"><span class="CharOverride-2"><a href="#/FranklinAve14">Acknowledgments</a></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// FranklinAve-2.vue?5ae05828